import { clean_phone, clean_string } from './tenant_settings_common_helpers';

export function tenant_setup_contact_name(form = {}) {
  const name_parts = clean_string(form.primary_contact)
    .split(/\s+/)
    .filter(Boolean);

  const name = Object.fromEntries([]);
  name.first_name = name_parts.slice(0, -1).join(' ');
  name.last_name = name_parts.slice(-1).join('');
  return name;
}

function validate_required_project_fields(form = {}) {
  return clean_string(form.organisation_name)
    ? ''
    : 'Organisation name is required.';
}

function validate_primary_contact_name(form = {}, contact_name = {}) {
  if (!clean_string(form.primary_contact)) {
    return 'Primary contact is required.';
  }

  return contact_name.first_name && contact_name.last_name
    ? ''
    : 'Enter the primary contactâ€™s first and last name.';
}

function validate_contact_details(form = {}) {
  const email = clean_string(form.primary_email);
  const phone = clean_phone(form.primary_phone);

  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return 'Enter a valid primary email address.';
  }

  return phone.length === 10
    ? ''
    : 'Primary contact phone number must contain 10 digits.';
}

export function collect_tenant_setup_errors(form = {}) {
  const contact_name = tenant_setup_contact_name(form);
  const validators = [
    () => validate_required_project_fields(form),
    () => validate_primary_contact_name(form, contact_name),
    () => validate_contact_details(form)
  ];

  return validators.map((validate) => validate()).find(Boolean) || '';
}

export function validate_tenant_setup_organisation(component) {
  const error = collect_tenant_setup_errors(component.tenant_setup_form);
  if (!error) {
    return true;
  }

  component.show_error(error);
  return false;
}
